import React from 'react';
import {coreUrls} from 'core_src/js/core_urls_config';
import {userStatus} from 'core_src/js/user_config';

/**
 * Component for creating the paywall card that is reused between the different paywall states.
 *
 * Takes a single `header` property which is used as the title of the card.
 *
 * The contents of the card come from the children elements.
 *
 * @example
 *  <PaywallCard header="Subscribe Now">
 *      <div>
 *          Subscribe today for great deals.
 *      </div>
 *  </PaywallCard>
 *
 * @param header - The header to use for the card.
 * @param children - The jsx children elements that should be rendered inside the card.
 * @param loginNextUrl - The page to redirect back to after logging in.
 * @param {null} footer - The footer to use for the card
 * @returns {*}
 * @constructor
 */
export function PaywallCard({header, children, loginNextUrl=null, footer=null}) {
    let loginUrl = coreUrls.login;

    if (loginNextUrl != null) {
        loginUrl += `?next=${loginNextUrl}`
    }

    return (
        <div className="paywall-card">
            <div className="paywall-card__contents">
                <div className="paywall-card__header">{header}</div>
                <div className="paywall-card__login_reminder">
                    Already have a subscription? {
                    userStatus.authenticated ?
                        (<a href={coreUrls.account_link_subscription}>Request digital access</a>) :
                        (<a href={loginUrl}>Log in</a>)
                }
                </div>
                <div className="paywall-card__body">{children}</div>
                <div className="paywall-card__footer">
                    <div className="registration-wall__fine-print">{footer}</div>
                </div>
            </div>
        </div>
    )
}
